/**
 * Normalizes an email address by trimming whitespace and converting it
 * to lowercase. When removeDots is true (the default), removes periods
 * from the local part of Gmail and Googlemail addresses. When removeDots
 * is false, only trims and lowercases.
 *
 * @param {string} email - The email address to normalize.
 * @param {boolean} [removeDots=true] - When true, strips periods from the local part of Gmail and Googlemail addresses. When false, only trims and lowercases.
 * @returns {string} The normalized email address.
 */
export function normalizeEmail(email, removeDots = true) {
	email = (email || '').trim().toLowerCase();

	if (!removeDots) {
		return email;
	}

	const [local, domain] = email.split('@');
	if (domain === 'gmail.com' || domain === 'googlemail.com') {
		return local.replace(/\./g, '') + '@' + domain;
	}
	return email;
}
